import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { cloneElement, useCallback, Children } from 'react';
import { DialogTrigger, MenuTrigger, Button as Button$1, Text, ActionButton as ActionButton$1, Divider as Divider$1, TooltipTrigger, Tooltip, Menu, Item, Flex, ToggleButton as ToggleButton$1, Breadcrumbs as Breadcrumbs$1, Grid } from '@adobe/react-spectrum';
import _extends from '@babel/runtime/helpers/esm/extends';
import MoreSmall from '@spectrum-icons/workflow/MoreSmall';
import { defineMessages, useIntl } from 'react-intl';
import ShowMenu from '@spectrum-icons/workflow/ShowMenu';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import ChevronLeft from '@spectrum-icons/workflow/ChevronLeft';
import { IntlProvider } from '@quarry/intl';
import { Tabs as Tabs$1, TabList, Item as Item$1 } from '@react-spectrum/tabs';

var _excluded$1 = ["children", "onPress", "value", "variant"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];
function ButtonWrapper(props) {
  var children = props.children,
      dialog = props.dialog,
      menu = props.menu;

  if (dialog) {
    return /*#__PURE__*/React.createElement(DialogTrigger, null, children, dialog);
  } else if (menu) {
    return /*#__PURE__*/React.createElement(MenuTrigger, null, children, menu);
  }

  return children;
}

function Button(props) {
  var children = props.children,
      onPress = props.onPress,
      value = props.value,
      variant = props.variant,
      wrapperProps = _objectWithoutProperties(props, _excluded$1);

  return /*#__PURE__*/React.createElement(ButtonWrapper, wrapperProps, /*#__PURE__*/React.createElement(Button$1, {
    variant: variant,
    onPress: function onButtonPress() {
      return !!onPress && onPress(value || children);
    }
  }, /*#__PURE__*/React.createElement(Text, null, children)));
}

function CTAButton(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "cta"
  }, otherProps), children);
}
function SecondaryButton(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded3);

  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "secondary"
  }, otherProps), children);
}

var _excluded = ["children", "icon", "onPress", "value"];
var ActionButton = function (props) {
  var children = props.children,
      icon = props.icon,
      onPress = props.onPress,
      value = props.value,
      wrapperProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(ButtonWrapper, wrapperProps, /*#__PURE__*/React.createElement(ActionButton$1, {
    onPress: function onButtonPress() {
      return !!onPress && onPress(value || children);
    }
  }, icon, /*#__PURE__*/React.createElement(Text, null, children)));
};

var Divider = function () {
  return /*#__PURE__*/React.createElement(Divider$1, {
    size: "S",
    orientation: "vertical",
    marginX: 16
  });
};

var ActionButtonGroup = function (props) {
  var actions = props.actions,
      _props$menuAlign = props.menuAlign,
      menuAlign = _props$menuAlign === void 0 ? 'end' : _props$menuAlign,
      _props$maxVisibleActi = props.maxVisibleActions,
      maxVisibleActions = _props$maxVisibleActi === void 0 ? 0 : _props$maxVisibleActi,
      _props$iconOnly = props.iconOnly,
      iconOnly = _props$iconOnly === void 0 ? false : _props$iconOnly,
      onActionSelect = props.onActionSelect;

  if (!actions || !actions.length) {
    return null;
  }

  var renderVisibleButton = function (action, i) {
    var button = /*#__PURE__*/React.createElement(ActionButton$1, {
      key: i,
      isQuiet: true,
      onPress: onActionSelect
    }, action.icon, !iconOnly && /*#__PURE__*/React.createElement(Text, null, action.label)); // eslint-disable-next-line @typescript-eslint/explicit-function-return-type

    return iconOnly ? /*#__PURE__*/React.createElement(TooltipTrigger, {
      delay: 0,
      placement: "top"
    }, button, /*#__PURE__*/React.createElement(Tooltip, null, action.label)) : button;
  };

  var buttonActions = actions.slice(0, maxVisibleActions);
  var menuActions = actions.slice(maxVisibleActions);
  var flexChildren = [];
  buttonActions.map(function (action, i) {
    i > 0 && flexChildren.push( /*#__PURE__*/React.createElement(Divider, {
      key: flexChildren.length
    }));
    flexChildren.push(renderVisibleButton(action, flexChildren.length));
  });

  if (menuActions.length > 0) {
    flexChildren.push( /*#__PURE__*/React.createElement(Divider, {
      key: flexChildren.length
    }));
    flexChildren.push( /*#__PURE__*/React.createElement(MenuTrigger, {
      align: menuAlign
    }, /*#__PURE__*/React.createElement(ActionButton$1, {
      "aria-label": "additional actions",
      isQuiet: true,
      onPress: onActionSelect
    }, /*#__PURE__*/React.createElement(MoreSmall, null)), /*#__PURE__*/React.createElement(Menu, {
      onAction: onActionSelect
    }, menuActions.map(function (action, i) {
      return /*#__PURE__*/React.createElement(Item, {
        key: i,
        textValue: action.label
      }, action.icon && /*#__PURE__*/cloneElement(action.icon, {
        size: "S"
      }), /*#__PURE__*/React.createElement(Text, null, action.label));
    }))));
  }

  return /*#__PURE__*/React.createElement(Flex, {
    gap: "size-125",
    direction: "row",
    justifyContent: "end"
  }, flexChildren);
};

var messages$1 = defineMessages({
  showMenu: {
    id: 'headers.openMenu',
    defaultMessage: 'Open menu'
  },
  hideMenu: {
    id: 'headers.hideMenu',
    defaultMessage: 'Hide menu'
  }
});
function ToggleButton(props) {
  var autoFocus = props.autoFocus,
      delay = props.delay,
      icon = props.icon,
      _props$isSelected = props.isSelected,
      isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
      onPress = props.onPress,
      textValue = props.textValue;
  var onSelectionChange = useCallback(function () {
    return onPress && onPress(!isSelected);
  }, [onPress]);
  var button = /*#__PURE__*/React.createElement(ToggleButton$1, {
    "aria-label": textValue,
    flexShrink: 0,
    isQuiet: true,
    isSelected: isSelected,
    autoFocus: autoFocus,
    onChange: onSelectionChange
  }, icon, isSelected && /*#__PURE__*/React.createElement(Text, null, textValue)); // show tooltip only when toggle button is not pressed

  if (!isSelected) {
    button = /*#__PURE__*/React.createElement(TooltipTrigger, {
      delay: delay,
      placement: "right"
    }, button, /*#__PURE__*/React.createElement(Tooltip, null, textValue));
  }

  return button;
}
function MenuToggleButton(props) {
  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var textValue = props.isSelected ? formatMessage(messages$1.hideMenu) : formatMessage(messages$1.showMenu);
  return /*#__PURE__*/React.createElement(ToggleButton, _extends({
    icon: /*#__PURE__*/React.createElement(ShowMenu, null),
    textValue: textValue
  }, props));
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Actions = function (props) {
  var children = props.children,
      onPress = props.onPress;

  var childProps = _objectSpread({}, onPress && {
    onPress: onPress
  });

  return /*#__PURE__*/React.createElement(Flex, {
    gridArea: "actions",
    gap: "size-100",
    flexGrow: 1,
    justifyContent: "end"
  }, Children.map(children, function (child) {
    return child && /*#__PURE__*/cloneElement(child, childProps);
  }));
};

var messages = defineMessages({
  back: {
    id: 'headers.back',
    defaultMessage: 'Back'
  }
});
function BackButton(props) {
  var onPress = props.onPress;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(ActionButton$1, {
    gridArea: "back",
    isQuiet: true,
    "aria-label": formatMessage(messages.back),
    onPress: onPress
  }, /*#__PURE__*/React.createElement(ChevronLeft, {
    size: "M"
  }));
}

var Breadcrumbs = function (props) {
  var onAction = props.onAction,
      path = props.path;
  return (path === null || path === void 0 ? void 0 : path.length) === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(Breadcrumbs$1, {
    flexGrow: 1,
    showRoot: path.length > 1,
    onAction: onAction
  }, path.map(function (bc) {
    return /*#__PURE__*/React.createElement(Item, {
      key: bc.key
    }, bc.label);
  }));
};

var en_us = {
	"headers.back": "Back",
	"headers.hideMenu": "Hide menu",
	"headers.openMenu": "Open menu"
};

var ko_kr = {
	"headers.back": "뒤로",
	"headers.hideMenu": "메뉴 숨기기",
	"headers.openMenu": "메뉴 열기"
};

var zh_tw = {
	"headers.back": "返回",
	"headers.hideMenu": "隱藏選單",
	"headers.openMenu": "開啟選單"
};

var zh_cn = {
	"headers.back": "返回",
	"headers.hideMenu": "隐藏菜单",
	"headers.openMenu": "打开菜单"
};

var pt_br = {
	"headers.back": "Voltar",
	"headers.hideMenu": "Ocultar menu",
	"headers.openMenu": "Abrir menu"
};

var it_it = {
	"headers.back": "Indietro",
	"headers.hideMenu": "Nascondi menu",
	"headers.openMenu": "Apri menu"
};

var es_es = {
	"headers.back": "Atrás",
	"headers.hideMenu": "Ocultar menú",
	"headers.openMenu": "Abrir menú"
};

var ja_jp = {
	"headers.back": "戻る",
	"headers.hideMenu": "メニューを非表示",
	"headers.openMenu": "メニューを開く"
};

var de_de = {
	"headers.back": "Zurück",
	"headers.hideMenu": "Menü ausblenden",
	"headers.openMenu": "Menü öffnen"
};

var fr_fr = {
	"headers.back": "Retour",
	"headers.hideMenu": "Masquer le menu",
	"headers.openMenu": "Ouvrir le menu"
};

/* istanbul ignore file */

var localizationMessages = /*#__PURE__*/Object.freeze({
  __proto__: null,
  en_US: en_us,
  ko_KR: ko_kr,
  zh_TW: zh_tw,
  zh_CN: zh_cn,
  pt_BR: pt_br,
  it_IT: it_it,
  es_ES: es_es,
  ja_JP: ja_jp,
  de_DE: de_de,
  fr_FR: fr_fr
});

var Header = function (props) {
  var children = props.children,
      height = props.height,
      minHeight = props.minHeight,
      layout = props.layout,
      locale = props.locale;

  if (layout === 'inventory') {
    return /*#__PURE__*/React.createElement(IntlProvider, {
      locale: locale,
      messages: localizationMessages
    }, /*#__PURE__*/React.createElement(Grid, {
      width: "100%",
      areas: ['back title actions', 'status status actions', 'tabs tabs tabs'],
      columns: ['auto', '1fr', 'auto']
    }, children));
  }

  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: localizationMessages
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    alignItems: "center",
    height: height,
    minHeight: minHeight
  }, children));
};

function Tabs(props) {
  var titles = props.titles,
      onSelectionChange = props.onSelectionChange;
  var tabs = titles.map(function (title) {
    return {
      name: title
    };
  });
  return /*#__PURE__*/React.createElement(Tabs$1, {
    gridArea: "tabs",
    items: tabs,
    onSelectionChange: onSelectionChange
  }, /*#__PURE__*/React.createElement(TabList, null, function (_ref) {
    var name = _ref.name;
    return /*#__PURE__*/React.createElement(Item$1, {
      key: name
    }, name);
  }));
}

var Title = function (props) {
  var children = props.children; // todo: replace with RSP typography component when available

  return /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold',
      minHeight: 'size-400',
      padding: '0 8px',
      margin: 0
    }
  }, children);
};

export { ActionButton, ActionButtonGroup, Actions, BackButton, Breadcrumbs, CTAButton, Divider, Header, MenuToggleButton, SecondaryButton, Tabs, Title, ToggleButton };
//# sourceMappingURL=index.esm.js.map
